import { GetterTree, MutationTree, ActionTree } from "vuex";
import { CardTypeApi } from "@/services/api/CardTypeApi";

class State {
  isCardTypeBusy: boolean;
  cardTypeItems: unknown [];
  cardTypeItem: unknown;
}

// Создаем объект
const cardTypeApi = new CardTypeApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isCardTypeBusy(state): boolean {
    return state.isCardTypeBusy;
  },

  getCardTypeItems(state): unknown[] {
    return state.cardTypeItems;
  },

  getCardTypeItem(state): unknown {
    return state.cardTypeItem;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsCardTypeBusy(state, payload: boolean) {
    state.isCardTypeBusy = payload
  },

  setCardTypeItems(state, payload: unknown[]) {
    state.cardTypeItems = payload
  },

  setCardTypeItem(state, payload: unknown) {
    state.cardTypeItem = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{
  
  // Устанавливаем элемент
  setCardTypeItem({ commit }, data: any) {
    commit('setCardTypeItem', data);
  },
  
  // Список элементов
  getCardTypeItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCardTypeBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      cardTypeApi.getCardTypeItems(filter, sort, pagination)
        .then(
          (response:any) => {
            for (const i in response) {

              if (response[i].getTypeId() == 1) {
                commit('setCardTypeItem', response[i]);
                break;
              }
            }

            commit('setCardTypeItems', response);
            commit('setIsCardTypeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCardTypeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Получить элемент
  getCardTypeItem({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCardTypeBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};

    return new Promise((resolve, reject) => {

      // Получаем элемент
      cardTypeApi.getCardTypeItem(filter)
        .then(
          (response) => {
            commit('setCardTypeItem', response);
            commit('setIsCardTypeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCardTypeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createCardTypeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCardTypeBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      cardTypeApi.createCardTypeItem(data)
        .then(
          (response) => {
            commit('setIsCardTypeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCardTypeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateCardTypeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCardTypeBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      cardTypeApi.updateCardTypeItem(data)
        .then(
          (response) => {
            commit('setIsCardTypeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCardTypeBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteCardTypeItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCardTypeBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      cardTypeApi.deleteCardTypeItem(data)
        .then(
          (response) => {
            commit('setIsCardTypeBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCardTypeBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const CardTypeModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default CardTypeModule;